import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMailQuestion } from "@tabler/icons-react";
import { SolicitudesRuteoImportacionDef } from "./SolicitudesRuteoImportacionDef";

export const SolicitudesRuteoIcon = IconMailQuestion;
export const SolicitudesRuteoHelpText = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

export class SolicitudesRuteoImportacion extends Entity<SolicitudesRuteoImportacionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new SolicitudesRuteoImportacionDef(), parentKeys);
        this.Form = import('./SolicitudesRuteoImportacionForm').then((module) => module.SolicitudesRuteoImportacionForm);
        this.Title = "Solicitudes de Ruteo";
        this.HelpText = SolicitudesRuteoHelpText;
        this.Icon = SolicitudesRuteoIcon;
    }
}